import React from 'react'
import NewRegistration from './NewRegistration'
import { useNavigate } from 'react-router-dom'

const NewRegistrationFnCom = () => {
    const navigate = useNavigate()
    return (
        <>
            <NewRegistration navigate={navigate} />
        </>
    )
}

export default NewRegistrationFnCom